import { walk } from "src/components/TreeStd";
import { deleteNodeRecursively } from "src/components/TreeStd/utils/deleteNodeRecursively";
import { AttrTypeName } from "src/types/AttrType";
import { ZAttribute } from "src/types/ZAttribute";
import { ZAttrLabelTreeData } from "../types/ZAttrLabelTreeData";

export const filterAttrLabelData = (
  labelTreeData: ZAttrLabelTreeData[],
  attibutes: ZAttribute[],
  typesMap: Record<number, string>,
  exclude: AttrTypeName[],
) => {
  let copy = JSON.parse(JSON.stringify(labelTreeData)) as ZAttrLabelTreeData[];
  const attrsMap = new Map(attibutes.map((e) => [e.id, e]));
  walk((node) => {
    const attr = attrsMap.get(node.attrId);
    if (!attr) return;
    const type = typesMap[attr.valueType] as AttrTypeName;
    if (exclude.includes(type)) {
      copy = deleteNodeRecursively(copy, node.key);
    }
  }, copy);
  return copy;
};
